// RemittanceOffice Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get remittanceOfficeList from backend then update remittanceOfficeList in vuex store ***** //
export const updateRemittanceOfficeList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('remittance_offices_index', {
      params: params
    })
    commit('updateRemittanceOfficeList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch RemittanceOffice from backend ***** //
export const fetchRemittanceOfficeInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`remittance_offices_show/${payload}`)
    commit('fetchRemittanceOfficeInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add RemittanceOffice  ***** //
export const addRemittanceOffice = async (ignored, payload = null) => {
  try {
    await Axios.post('remittance_offices_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update RemittanceOffice  info ***** //
export const updateRemittanceOfficeInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`remittance_offices_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete RemittanceOffice  ***** //
export const deleteRemittanceOffice = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`remittance_offices_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullRemittanceOfficesList = async ({ commit }) => {
  let remittanceOfficesList = []

  try {
    const result = await Axios.get('remittance_offices_list')
    result.data.data.forEach(remittanceOffice => {
      remittanceOfficesList.push({
        value: remittanceOffice.remittance_office_id,
        text: remittanceOffice.remittance_office_name
      })
    })
    commit('setFullRemittanceOfficesList', remittanceOfficesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
